module.exports = __webpack_public_path__ + "static/media/shopping.8bc3351d.svg";